import React from 'react'
import { NavLink } from 'react-router-dom';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import { IconButton } from '@mui/material';

import { ProfileContent, useProovedorData, returnFullURL } from '..'
import ButtonLoader from './ButtonLoader';

const UserDropdown = ({ handleModal }) => {
    const { data_user, handleLogout, main_data, loadImageS, globalLoaders } = useProovedorData() || [];
    const styles_icon_dropdown = { color: 'gray', marginRight: 1 };

    return (
        <>
            {data_user?.authCode != null ? (
                <div className='navbar-profile'>
                    <ProfileContent profile_url={data_user?.perfil} loadImageS={loadImageS} />
                    <ul className='user-dropdown'>
                        <div style={{ maxHeight: '70vh', overflow: 'auto' }}>
                            {
                                ((main_data?.companys && main_data?.companys) || []).map(data => (
                                    <li className='company-list-mobile'>
                                        <NavLink to={data.nit ? ("/administrar/negocio/productos/" + data.nit) : "/"} style={{ width: '100%', display: 'flex', gap: '5px', alignItems: 'center' }}>
                                            <div className='profile-img' style={{ minWidth: 'var(--same-size)', height: 'var(--same-size)' }}>
                                                <img src={returnFullURL(data?.icon ?? null)} alt={'Empresa ' + data.nameComany} />
                                            </div>
                                            <span className='limited-text'>{data.nameComany}</span>
                                        </NavLink>
                                    </li>
                                ))
                            }
                        </div>

                        <li className='company-list-mobile' >
                            <span style={{ width: '100%', border: '1.5px solid var(--color-secundary)' }}></span>
                        </li>

                        <li>
                            <NavLink to={`/user/posts`} >
                                <AccountCircleIcon sx={styles_icon_dropdown} />
                                Perfil
                            </NavLink>
                        </li>

                        <li>
                            <NavLink to="/productos">
                                <SettingsIcon sx={styles_icon_dropdown} />
                                Configuración
                            </NavLink>
                        </li>

                        <li>
                            <ButtonLoader type='button' onClick={handleLogout} state_progress={globalLoaders?.login} colorProgress='var(--empresa-color)'>
                                <LogoutIcon sx={styles_icon_dropdown} />
                                Salir
                            </ButtonLoader>
                        </li>
                    </ul>
                </div>
            ) : (
                <IconButton className='navbar-profile' title='Iniciar Sesion' onClick={() => handleModal(true)}>
                    <LoginIcon className='li-icon' sx={{ color: 'var(--empresa-color)' }} />
                </IconButton>
            )}
        </>
    )
}

export default UserDropdown